module.exports = __webpack_public_path__ + "img/9.8ea884f8.svg";